import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import Grid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import ContextoService from '../../services/Contexto';
import { errors } from '../../services/API';

import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import Title from '../../components/Title/Title';
import Text from '../../components/Inputs/Text/Text';
import SelectOption from '../../components/Inputs/Select/Select';
import Toast from "../../components/Toast/Toast";
import Loading from '../../components/Loading/Loading';

import ButtonsForm from '../../forms/Buttons/ButtonsForm';

import { optionsType, optionsGrupoExibicao } from '../../variables/Enums/Contexto';

import { 
    isBlank, 
    isBlankHelperText, 
    isNotNumber, 
    isNumberHelperText
} from '../../helper/ValidationHelper';
import { numberMask } from '../../helper/MaskHelper';
import { filterPersistence } from '../../helper/ParseStateHelper';

import { Layout } from '../../layouts/private/Private';

class Form extends Component {
    constructor(props) {
        super(props);
        this.state = {
            context: {
                id: !isNaN(this.props.match.params.id) ? this.props.match.params.id : '',
                name: '',
                type: '',
                ordemExibicao: '',
                value: '',
                legenda: '',
                grupoExibicao: '',
            },
            errors: {
                name: false,
                type: false,
                ordemExibicao: false,
                grupoExibicao: false,
            },
            helpers: {
                name: null,
                type: null,
                ordemExibicao: null,
                grupoExibicao: null,
            },
            typeInitial: '',
            loadingButtonSave: false,
            loading: this.props.match.params.id ? true : false,
            history: {
                path: null,
                state: null,
            }
        };
    }

    // INPUTS
    handleChange = e => {
        this.setState({
            context: {...this.state.context, [e.target.name]: e.target.name === 'ordemExibicao' ? numberMask(e.target.value) : e.target.value },
            errors: {...this.state.errors, [e.target.name]: false },
            helpers: {...this.state.helpers, [e.target.name]: null }
        });
    };

    handleChangeLegenda = editor => {
        this.setState({
            ...this.state,
            context: {
                ...this.state.context,
                legenda: editor.getData()
            }
        })
    }

    // DECLARAÇÃO DE REFERÊNCIA DOS COMPONENTES
    setToast = t => this.Toast = t;

    // VALIDAÇÃO
    isValid = () => {
        if ( isBlank(this.state.context.name) || isBlank(this.state.context.type) || isBlank(this.state.context.ordemExibicao) || isNotNumber(this.state.context.ordemExibicao)
                || isBlank(this.state.context.grupoExibicao) ) {
            this.setState({ 
                errors: {
                    name: isBlank(this.state.context.name) ? true : false,
                    type: isBlank(this.state.context.type) ? true : false,
                    ordemExibicao: isBlank(this.state.context.ordemExibicao) || isNotNumber(this.state.context.ordemExibicao) ? true : false,
                    grupoExibicao: isBlank(this.state.context.grupoExibicao) ? true : false,
                },
                helpers: {
                    name: isBlank(this.state.context.name) ? isBlankHelperText() : null,
                    type: isBlank(this.state.context.type) ? isBlankHelperText() : null,
                    ordemExibicao: isBlank(this.state.context.ordemExibicao) ? isBlankHelperText() : isNotNumber(this.state.context.ordemExibicao) ? isNumberHelperText() : null,
                    grupoExibicao: isBlank(this.state.context.grupoExibicao) ? isBlankHelperText() : null,
                },
            })
            return false
        }
        return true
    }

    // SALVAR
    handleSubmit = () => {
        this.setState({ loadingButtonSave: true });

        const formIsValid = this.isValid()
        
        if ( !formIsValid ) {
            this.setState({ loadingButtonSave: false });
            return
        }       

        const context = {
            nmTipo: this.state.context.type,
            nmVariavel: this.state.context.name,
            nmValor: this.state.typeInitial === this.state.context.type ? this.state.context.value : null,
            nmOrdemExibicao: this.state.context.ordemExibicao,
            nmLegenda: this.state.context.legenda,
            nmAgrupamento: this.state.context.grupoExibicao,
        } 
        
        let msgSuccess = '';
        let request = '';

        if (this.state.context.id) {
            request = ContextoService.edit(this.state.context.id, context);
            msgSuccess = "Variável de Contexto Atualizada com Sucesso.";
        } else {
            msgSuccess = "Variável de Contexto Criada com Sucesso.";
            request = ContextoService.add(context);
        }

        request
            .then(res => {
                this.Toast.setState({
                    message: {
                        message: msgSuccess,
                        type: "success",
                        open: true
                    }
                });

                setTimeout(() => this.handleBack(), 1000);
            })
            .catch(error => {
                const e = errors(error);
                this.Toast.setState({
                    message: {
                        message: e.message,
                        type: e.type,
                        open: true
                    }
                })
                this.setState({ loadingButtonSave: false });
            })
    }

    componentDidMount() {
        this.setState({ history: filterPersistence(this.props.location) });

        if (this.state.context.id) {
            ContextoService.find(this.state.context.id)
                .then(res => {
                    this.setState({
                        context: {
                            id: res.data.cdVariavel,
                            name: res.data.nmVariavel,
                            type: res.data.nmTipo,
                            ordemExibicao: res.data.nmOrdemExibicao,
                            value: res.data.nmValor,
                            legenda: res.data.nmLegenda,
                            grupoExibicao: res.data.nmAgrupamento,
                        },
                        typeInitial: res.data.nmTipo,
                        loading: false,
                    });
                })
                .catch(err => {
                    this.Toast.setState({
                        message: {
                            message: "Não Foi Possível Buscar a Variável de Contexto para Edição.",
                            type: 'error',
                            open: true
                        }
                    })

                    this.setState({ loading: false })
                })
        }
    }

    handleBack = () => {        
        this.props.history.push({
            pathname: this.state.history.path ? `${this.state.history.path}` : `/admin/contexto/listagem`,
            state: {
                history: {
                    state: this.state.history.state
                }
            }
        });
    }

    render () {
        const page = this.state.context.id ? 'Editar Variável' : 'Adicionar Variável';
        const links = [
            {
                path: null,
                name: 'Configurações'
            },
            {
                path: '/admin/contexto',
                name: 'Contexto'
            },
            {
                path: { 
                    pathname: this.state.history.path ? `${this.state.history.path}` : `/admin/contexto/listagem`,
                    state: {
                        history: {
                            state: this.state.history.state
                        }
                    }
                },
                name: 'Listagem'
            }
        ];

        return (
            <Layout>
                <Toast parentRef={this.setToast} />
                <Grid container >
                    <Grid item xs={12}>
                        <Breadcrumbs links={links} active={page} />
                    </Grid>
                </Grid>

                <Title>{page}</Title>

                { this.state.loading ? 
                    <Loading />
                :
                    <>
                        <Grid container spacing={3} alignItems='center'>
                            <Grid item sm={12} lg={3}>
                                <Text
                                    required
                                    name="name"
                                    label="Nome da Variável"
                                    value={this.state.context.name}
                                    error={this.state.errors.name}
                                    onChange={this.handleChange}
                                    helperText={this.state.helpers.name}
                                />
                            </Grid>
                            <Grid item sm={12} lg={3}>
                                <SelectOption 
                                    required
                                    name="type"
                                    label="Tipo de Variavel"
                                    options={optionsType}
                                    value={this.state.context.type}
                                    error={this.state.errors.type}
                                    onChange={this.handleChange}
                                    hiddenblank="true"
                                    helperText={this.state.helpers.type}
                                />
                            </Grid>
                            <Grid item sm={12} lg={2}>
                                <SelectOption 
                                    required
                                    name="grupoExibicao"
                                    label="Grupo de Exibição"
                                    options={optionsGrupoExibicao}
                                    value={this.state.context.grupoExibicao}
                                    error={this.state.errors.grupoExibicao}
                                    onChange={this.handleChange}
                                    helperText={this.state.helpers.grupoExibicao}
                                />
                            </Grid>
                            <Grid item sm={12} lg={1}>
                                <Text
                                    required
                                    name="ordemExibicao"
                                    label="Ordem de Exibição"
                                    value={this.state.context.ordemExibicao}
                                    error={this.state.errors.ordemExibicao}
                                    onChange={this.handleChange}
                                    helperText={this.state.helpers.ordemExibicao}
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={3} alignItems='center'>
                            <Grid item sm={12} lg={1}>
                                <Typography variant="body2" display="inline" style={{ fontSize: 12, color: 'rgba(0, 0, 0, 0.54)' }}>
                                    Texto Informativo:
                                </Typography>
                            </Grid>
                            <Grid item sm={12} lg={9}>
                                <CKEditor
                                    editor={ClassicEditor}
                                    data={this.state.context.legenda}
                                    config={{
                                        toolbar: [],
                                        language: 'pt-br',
                                    }}
                                    onChange={(event, editor) => this.handleChangeLegenda(editor)}
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={3} alignItems='center'>
                            <ButtonsForm 
                                onClick={this.handleSubmit} 
                                onBack={this.state.history.path ? () => this.handleBack() : null} 
                                loading={this.state.loadingButtonSave} 
                            />
                        </Grid>
                    </>
                }
            </Layout>
        )
    }
}

export default withRouter(Form);